import { LoaderSizes, SystemIconSizes } from './types';

export const SIZE_MAP: Record<LoaderSizes, SystemIconSizes> = {
    sm: 16,
    md: 20,
    lg: 24,
};

export const LOADER_TEST_ID = 'feedback-loader';
